/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/variants" DataTable endpoint.
 * Fetches user-authored creative variants for one creative component and returns them
 * in the standard DataTable format ({ hits, results }).
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants } from "./constants";
import type {
  DecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsParams,
  GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsResult,
  RawCreativeVariantsResponse,
} from "./types";
import { isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsResult } from "./validators";

export const getDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants =
  reactQueryTableFetcherAdapter(
    decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants,
    async (
      signal: AbortSignal,
      {
        appGroupId,
        dsaId,
        component,
        limit,
        start = 0,
        query,
      }: DecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsParams
    ): Promise<GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsResult> => {
      const rawResponse = await fetch<RawCreativeVariantsResponse>(
        `/decisioning_studio_agents/${appGroupId}/${dsaId}/creative_components/${component}/variants`,
        "GET",
        { start, limit, search_term: query?.search_term },
        { signal }
      );

      return {
        hits: rawResponse.hits,
        results: rawResponse.results.map((item) => ({
          id: String(item.variant_id),
          creative: item.creative,
          compatible_base_creative_campaign_ids: item.compatible_base_creative_campaign_ids,
        })),
      };
    },
    isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsResult
  );
